if (!customElements.get('flo-checkout')) {
  class FloCheckout extends HTMLElement {
    connectedCallback() {
      const btn = this.querySelector('a, button');
      if (btn) btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleCheckout();
      });
    }

    setLoading(isLoading) {
      const btn = this.querySelector('a, button');
      if (!btn) return;

      if (isLoading) {
        btn.dataset.originalText = btn.textContent.trim();
        btn.textContent = 'Loading...';
        btn.style.opacity = '0.6';
        btn.style.pointerEvents = 'none';
        btn.style.cursor = 'wait';

        this._loadingTimer = setTimeout(() => {
          this.setLoading(false);
        }, 5000);

      } else {
        clearTimeout(this._loadingTimer);
        btn.textContent = btn.dataset.originalText || 'Buy Now';
        btn.style.opacity = '';
        btn.style.pointerEvents = '';
        btn.style.cursor = '';
      }
    }

    async handleCheckout() {
      const variantId = this.dataset.floVariant;
      if (!variantId) return console.error('[flo-checkout] Missing data-flo-variant');

      this.setLoading(true);

      try {
        const clearRes = await fetch('/cart/clear.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
        });
        if (!clearRes.ok) throw new Error(`Cart clear failed: ${clearRes.status}`);

        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });
        if (!addRes.ok) throw new Error(`Add to cart failed: ${addRes.status}`);

        await addRes.json();

        if (typeof handleFloCheckoutBtn === 'function') {
          handleFloCheckoutBtn();
        } else {
          console.error('[flo-checkout] handleFloCheckoutBtn is not defined');
        }
      } catch (err) {
        console.error('[flo-checkout]', err);
        this.setLoading(false);
      }
    }
  }

  customElements.define('flo-checkout', FloCheckout);
}